export const environment = {
  production: true,
  environmentName: 'production',
  authTokenKey: 'ce4d54234342343_token',
  backendEndpoint: 'https://wl-api-live.quickbus.com/api/v1/',
  rollbarKey: '884e3ed170344ae0ac3e0c7e4f9ce215',
  VAPID_PUBLIC_KEY: 'BJhPl1rWmJcYx33WbAf9fcYfn10x73iBzOXUzFWc1iolPkK2rjpo821fm7j65v8UDGi8oPPA2sWQffZXiFXnRok',
  S3_ASSETS_BASE: 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/',
  S3_MEDIA_BASE: 'https://s3.eu-west-3.amazonaws.com/media.quickbus.com/',
  mainEndpoint: 'https://live.api.quickbus.com/v2/',
  siteUnderConstructionUrl: 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/under-construction-prod.json',
  updateDate: 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/last-forced-cache-update.json'
};
